/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-c11][_ngcontent-%COMP%]   table[_ngcontent-%COMP%], [_nghost-c11][_ngcontent-%COMP%]   td[_ngcontent-%COMP%], [_nghost-c11][_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{padding:5px!important}[_nghost-c11][_ngcontent-%COMP%]   a.page-indicator[_ngcontent-%COMP%]{padding:0!important}td[_ngcontent-%COMP%]{padding:0 0 0 15px!important;text-align:left}[_nghost-c11][_ngcontent-%COMP%]   .main_navigation[_ngcontent-%COMP%]{margin-top:-10px!important}"];
export { styles as styles };
